<template>
  <div style="padding=20px;" class="print-skin-regimen-record">
    <div class="row">
      <div class="col-3">
        <img v-if="true" :style="{
          marginLeft: '0px',
          width: `${logoWidth}px`,
        }" :src="this.companyClinicLogo" />
      </div>
      <div class="col-7">
      </div>
    </div>
    <div class="lh-lg">
      <h2 class="text-center">{{ getInvoiceClinic }}</h2>
      <h3 class="text-center"> <u>{{ $t('skinRegimen.subtitle') }}</u></h3>
      <br />
      <p class="text-center font-weight-bold">For <u>&nbsp;&nbsp;&nbsp;&nbsp; {{ patient.name }}
          &nbsp;&nbsp;&nbsp;&nbsp;</u> (Date of Visit: <u>&nbsp;&nbsp;&nbsp;&nbsp;{{ invoice.createdAt | formatVDDate({
            format: 'DD MMM YYYY'
          }) }}&nbsp;&nbsp;&nbsp;&nbsp;</u> )</p>
    </div>
    <br />
    <br />
    <div class="row mb-5">
      <div class="col-12">
        <div class="row mt-2">
          <div class="col-12">
            <span class="font-weight-bold"><u>Morning&nbsp;&nbsp;&nbsp;早</u>&nbsp;&nbsp;
              <v-icon name="sun" color="gold" scale="2.5" />
            </span>
          </div>
        </div>
        <br />
        <div class="row mt-2">
          <div class="col-2">
            <span class="font-weight-bold">Cleanser 洁面霜</span>
          </div>
          <div class="col-10">
            <span> {{ skinRegimenData.morningCleanserName || '' }} </span>
          </div>
        </div>
        <br />
        <div class="row mt-1">
          <div class="col-2 span-step">
            <span class="font-weight-bold span-step"> <i>Step(s)</i> 步骤</span>
          </div>
          <div class="col-10 span-step">
            <div v-for="(item, index) in skinRegimenData.morningCleanserSteps" :key="index">
              <div class="row" v-if="item.itemname || item.remark">
                <div class="col-5"><b>{{ index + 1 }}.</b> &nbsp;{{ item.itemname || '' }} </div>
                <div class="col-7">{{ item.remark || '' }} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="row mt-2">
          <div class="col-12">
            <span class="font-weight-bold"><u>Night&nbsp;&nbsp;&nbsp;晚</u>
              &nbsp;&nbsp;
              <v-icon name="moon" color="gold" scale="2.5" />
            </span>
          </div>
        </div>
        <br />
        <div class="row mt-2">
          <div class="col-2">
            <span class="font-weight-bold">Cleanser 洁面霜</span>
          </div>
          <div class="col-10">
            <span> {{ skinRegimenData.nightCleanserName || '' }}</span>
          </div>
        </div>
        <br />
        <div class="row mt-1">
          <div class="col-2 span-step">
            <span class="font-weight-bold"><i>Step(s)</i> 步骤</span>
          </div>
          <div class="col-10 span-step">
            <div v-for="(item, index) in skinRegimenData.nightCleanserSteps" :key="index">
              <div class="row" v-if="item.itemname || item.remark">
                <div class="col-5" ><b>{{ index + 1 }}.</b> &nbsp;{{ item.itemname || '' }} </div>
                <div class="col-7">{{ item.remark || '' }} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-2">
        <v-icon class="left-top-icon" name="star-of-life" scale="0.5" /><span class="font-weight-bold"> Remarks:</span>
      </div>
      <div class="col-10">
        <span v-if="skinRegimenData.remarks && skinRegimenData.remarks.length > 0" class="multi-lines-content">
          <u>{{ skinRegimenData.remarks || '' }}</u>
        </span>
        <span v-else class="remark-empty">&nbsp;</span>
      </div>
    </div>


    <br/>
    <div class="mt-4">
      <p class="text-center">Please do not hesitate to call the Clinic Nurse for further advice when needed.</p>
      <p class="text-center">如有需要可打电话给诊所护士进一步的咨询。</p>
    </div>
    <br/>
    <div class="row location">
      <div class="col-4 contact">
        <p class="text-right">Niks Maple Clinic (6783 9038)</p>
        <p class="text-right">WhatsApp (8890 4973)</p>
      </div>
      <div class="col-4 contact">
        <p class="text-right">Niks Maple West Clinic (6776 7863)</p>
        <p class="text-right">WhatsApp (8854 3260)</p>
      </div>
      <div class="col-4 contact">
        <p class="text-right">Niks Maple Central Clinic (6235 9428)</p>
        <p class="text-right">WhatsApp (8168 2638)</p>
      </div>
    </div>
  </div>
</template>
<script>
import computedMixins from '@/components/mixins/computed';
import dateformatter from '@/components/mixins/dateformatter';
import moment from 'moment';
import skinRegimenService from '@/services/skinRegimen.service';

export default {
  name: 'SkinRegimenRecord',
  mixins: [dateformatter, computedMixins],
  props: {
    general: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      printDate: moment().format('YYYY/MM/DD'),
      skinRegimenData: {},
      invoice: {
        clinic: '',
        createdAt: '',
      },
      patient: {
        name: '',
      },
    };
  },
  computed: {
    companyClinicLogo() {
      return this.general.logoURL;
    },
    getInvoiceClinic() {
      return this.clinicsById[this.invoice.clinic]?.name || '';
    },
    visitDate() {
      return this.consultation && this.formatDate(this.consultation.visitDate);
    },
    logoWidth() {
      if (localStorage.getItem('printSetup')) {
        return JSON.parse(localStorage.getItem('printSetup')).logoWidth;
      }
      return 162;
    },
  },
  methods: {
    resetSkinRegimenData() {
      this.skinRegimenData = {
        morningCleanserName: '',
        morningCleanserSteps: [],
        nightCleanserName: '',
        nightCleanserSteps: [],
        remarks: '',
      };
    },
    async setSkinRegimenData() {
      const { id } = this.$route.query;
      const res = await skinRegimenService.findById(id);
      if (res && res.data) {
        this.patient = res.data.patient;
        this.invoice = res.data.invoice;
        this.skinRegimenData = {
          ...{
            morningCleanserName: '',
            morningCleanserSteps: [],
            nightCleanserName: '',
            nightCleanserSteps: [],
            remarks: '',
          },
          ...res.data,
        };
      }
    },
  },
  async created() {
    this.resetSkinRegimenData();
    await this.setSkinRegimenData();
  },
};
</script>

<style scoped src="../../assets/print.css"></style>
<style lang="scss" scoped>
.multi-lines-content {
  white-space: pre-line;
}

.print-skin-regimen-record {
  color: #000 !important;
}

.location {
  margin-right: 3rem;
}
.span-step {
  padding-top: 1.5rem;
}

.left-top-icon {
  margin-bottom: 1em;
}

.remark-empty {
  display: block;
  background-image: linear-gradient(to top, black 0px, transparent 1px);
  background-size: 100% 1.5em;
  line-height: 1.5em;
}

.contact {
  padding-right: 0;
  padding-left: 0;
}

@media print {
  .print-skin-regimen-record {
    color: #000 !important;
  }
  .remark-empty {
    display: block !important;
    background-image: linear-gradient(to top, black 0px, transparent 1px) !important;
    background-size: 100% 1.5em !important;
    line-height: 1.5em !important;
  }
}
</style>
